import { cloneDeep, isEmpty } from 'lodash'

function migrate(data) {
  const shouldMigrateIdeaBoard = typeof data.ui?.ideaBoard?.pocketIdeasUsed === 'undefined'

  const shouldAddBookmarks = !data.ui?.bookmarks
  const shouldMigrateBookmarks = typeof data.ui?.bookmarks?.collapsedSection === 'undefined'

  const shouldMigrateNotesTab =
    typeof data.ui?.noteTab?.showAsList === 'undefined' ||
    typeof data.ui?.noteTab?.collapsedCategories === 'undefined'

  const shouldMigrateCharacterTab =
    typeof data.ui.characterTab.showAsList === 'undefined' ||
    typeof data.ui.characterTab.collapsedCategories === 'undefined'

  const shouldMigratePlacesTab =
    typeof data.ui?.placeTab?.showAsList === 'undefined' ||
    typeof data.ui?.placeTab?.collapsedCategories === 'undefined'

  const shouldMigrateTheme = typeof data.ui?.theme === 'undefined'
  const shouldMigrateMobileControlsModal = isEmpty(data.ui.mobileControlsModal)

  const cardNeedsToBeMigrated = (card) => {
    return (
      !Array.isArray(card.notes) ||
      typeof card.positionInBeat === 'undefined' ||
      typeof card.color === 'undefined' ||
      typeof card.positionWithinLine === 'undefined'
    )
  }
  const aCardNeedsToBeMigrated = data.cards.some(cardNeedsToBeMigrated)
  const lineNeedsToBeMigrated = (line) => {
    return typeof line.pinnedPosition === 'undefined' || typeof line.characterId === 'undefined'
  }
  const aLineNeedsToBeMigrated = data.lines.some(lineNeedsToBeMigrated)
  const placeNeedsToBeMigrated = (place) => {
    return typeof place.categoryId === 'undefined' || typeof place.position === 'undefined'
  }
  const aPlaceNeedsToBeMigrated = data?.places?.some?.(placeNeedsToBeMigrated)
  const aBeatNeedsToBeMigrated = Object.values(data.beats).some((beatTree) => {
    return Object.values(beatTree.index).some((beat) => {
      return typeof beat.expanded === 'undefined'
    })
  })
  const characterNeedsToBeMigrated = (character) => {
    return typeof character.position === 'undefined' || typeof character.categoryId === 'undefined'
  }
  const aCharacterNeedsToBeMigrated = data.characters?.some?.(characterNeedsToBeMigrated)
  const noteNeedsToBeMigrated = (note) => {
    return (
      typeof note.position === 'undefined' ||
      typeof note.categoryId === 'undefined' ||
      typeof note.lastEdited === 'undefined'
    )
  }
  const aNoteNeedsToBeMigrated = data.notes?.some?.(noteNeedsToBeMigrated)

  const hoverDetails = data.ui?.outlineTab?.layout?.fulltext?.hoverDetails ?? {}
  const shouldAddTimelineFilter = typeof data.ui?.timeline?.filterVisible === 'undefined'
  const hasMissingHoverDetails =
    typeof hoverDetails !== 'object' ||
    typeof hoverDetails.lineTitle === 'undefined' ||
    typeof hoverDetails.beatTitle === 'undefined' ||
    typeof hoverDetails.cardTitle === 'undefined' ||
    typeof hoverDetails.cardId === 'undefined' ||
    typeof hoverDetails.visible === 'undefined'

  if (
    !shouldMigrateNotesTab &&
    !shouldMigrateIdeaBoard &&
    !shouldMigrateBookmarks &&
    !shouldAddBookmarks &&
    !shouldMigrateCharacterTab &&
    !shouldMigratePlacesTab &&
    !shouldMigrateTheme &&
    !shouldMigrateMobileControlsModal &&
    !aCardNeedsToBeMigrated &&
    !aLineNeedsToBeMigrated &&
    !aPlaceNeedsToBeMigrated &&
    !aBeatNeedsToBeMigrated &&
    !hasMissingHoverDetails &&
    !aCharacterNeedsToBeMigrated &&
    !aNoteNeedsToBeMigrated &&
    !shouldAddTimelineFilter
  ) {
    return data
  } else {
    const newData = cloneDeep(data)

    if (shouldAddTimelineFilter) {
      newData.ui.timeline = {
        ...newData.ui?.timeline,
        filterVisible: false,
      }
    }
    if (hasMissingHoverDetails) {
      newData.ui.outlineTab = {
        ...newData.ui.outlineTab,
        layout: {
          ...(typeof newData.ui.outlineTab?.layout === 'undefined'
            ? {}
            : {
                ...newData.ui.outlineTab?.layout,
              }),
          fulltext: {
            ...(typeof newData.ui.outlineTab?.layout?.fulltext === 'undefined'
              ? {}
              : {
                  ...newData.ui.outlineTab.layout.fulltext,
                }),
            hoverDetails: {
              lineTitle:
                typeof newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.lineTitle ===
                'undefined'
                  ? null
                  : newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.lineTitle,
              beatTitle:
                typeof newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.beatTitle ===
                'undefined'
                  ? null
                  : newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.beatTitle,
              cardTitle:
                typeof newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.cardTitle ===
                'undefined'
                  ? null
                  : newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.cardTitle,
              cardId:
                typeof newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.cardId === 'undefined'
                  ? null
                  : newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.cardId,
              visible:
                typeof newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.visible === 'undefined'
                  ? false
                  : newData.ui.outlineTab?.layout?.fulltext?.hoverDetails.visible,
            },
          },
        },
      }
    }
    if (!shouldAddBookmarks && shouldMigrateBookmarks) {
      newData.ui.bookmarks.collapsedSection = []
    }
    if (shouldAddBookmarks) {
      newData.ui.bookmarks = {
        items: [],
        collapsedSection: [],
      }
    }
    if (aCharacterNeedsToBeMigrated) {
      newData.characters = data.characters.map((character) => {
        if (characterNeedsToBeMigrated(character)) {
          return {
            ...character,
            ...(typeof character.categoryId === 'undefined'
              ? { categoryId: null }
              : { categoryId: character.categoryId }),
            ...(typeof character.position === 'undefined'
              ? { position: 0 }
              : { position: character.position }),
          }
        } else {
          return character
        }
      })
    }
    if (shouldMigrateIdeaBoard) {
      newData.ui.ideaBoard.pocketIdeasUsed = []
    }
    if (aNoteNeedsToBeMigrated) {
      newData.notes = data.notes.map((note) => {
        if (noteNeedsToBeMigrated(note)) {
          return {
            ...note,
            ...(typeof note.categoryId === 'undefined'
              ? { categoryId: null }
              : { categoryId: note.categoryId }),
            ...(typeof note.position === 'undefined'
              ? { position: 0 }
              : { position: note.position }),
            lastEdited: note.lastEdited || null,
          }
        } else {
          return note
        }
      })
    }
    if (aCharacterNeedsToBeMigrated) {
      newData.characters = data.characters.map((character) => {
        if (characterNeedsToBeMigrated(character)) {
          return {
            ...character,
            ...(typeof character.categoryId === 'undefined'
              ? { categoryId: null }
              : { categoryId: character.categoryId }),
            ...(typeof character.position === 'undefined'
              ? { position: 0 }
              : { position: character.position }),
          }
        } else {
          return character
        }
      })
    }
    if (shouldMigrateIdeaBoard) {
      newData.ui.ideaBoard.pocketIdeasUsed = []
    }
    if (aBeatNeedsToBeMigrated) {
      for (const beatTree of Object.values(newData.beats)) {
        for (const beat of Object.values(beatTree.index)) {
          if (typeof beat.expanded === 'undefined') {
            beat.expanded = true
          }
        }
      }
    }
    if (shouldMigrateNotesTab) {
      newData.ui.noteTab = {
        ...newData.ui.noteTab,
        showAsList:
          typeof newData.ui?.noteTab?.showAsList === 'undefined'
            ? true
            : newData.ui?.noteTab.showAsList,
        collapsedCategories:
          typeof newData.ui?.noteTab?.showAsList === 'undefined'
            ? false
            : newData.ui.noteTab.collapsedCategories,
      }
    }
    if (shouldMigrateCharacterTab) {
      newData.ui.characterTab = {
        ...newData.ui.characterTab,
        showAsList:
          typeof newData.ui.characterTab.showAsList === 'undefined'
            ? true
            : newData.ui.characterTab.showAsList,
        collapsedCategories:
          typeof newData.ui.characterTab.showAsList === 'undefined'
            ? false
            : newData.ui.characterTab.collapsedCategories,
      }
    }
    if (shouldMigratePlacesTab) {
      newData.ui.placeTab = {
        ...newData.ui.placeTab,
        showAsList:
          typeof newData.ui?.placeTab?.showAsList === 'undefined'
            ? true
            : newData.ui.placeTab?.showAsList,
        collapsedCategories:
          typeof newData.ui?.placeTab?.showAsList === 'undefined'
            ? false
            : newData.ui.placeTab.collapsedCategories,
      }
    }
    if (shouldMigrateTheme) {
      newData.ui.theme = null
    }
    if (shouldMigrateMobileControlsModal) {
      newData.ui.mobileControlsModal = {
        open: false,
      }
    }
    if (aCardNeedsToBeMigrated) {
      newData.cards = data.cards.map((card) => {
        if (cardNeedsToBeMigrated(card)) {
          return {
            ...card,
            notes: card.notes ?? [],
            positionInBeat: card.positionInBeat ?? null,
            color: card.color ?? null,
            positionWithinLine: card.positionWithinLine ?? 0,
          }
        } else {
          return card
        }
      })
    }
    if (aLineNeedsToBeMigrated) {
      newData.lines.forEach((line) => {
        if (typeof line.pinnedPosition === 'undefined') {
          line.pinnedPosition = null
        }
        if (typeof line.characterId === 'undefined') {
          line.characterId = null
        }
      })
    }
    if (aPlaceNeedsToBeMigrated) {
      newData.places = data.places.map((place) => {
        if (placeNeedsToBeMigrated(place)) {
          return {
            ...place,
            ...(typeof place.categoryId === 'undefined'
              ? { categoryId: null }
              : { categoryId: place.categoryId }),
            ...(typeof place.position === 'undefined'
              ? { position: 0 }
              : { position: place.position }),
          }
        } else {
          return place
        }
      })
    }
    return newData
  }
}

export default migrate
